import { useQuery } from "@tanstack/react-query";
import { GET } from "../services/requests";

export const useEpisode = (id: string | undefined, episodeId: string | undefined) => {
  const query = useQuery<any>(
    ["EPISODE", `${id}-${episodeId}`],
    async () => {
      const data = await GET(`serials/${id}/episodes/${episodeId}`);
      return data;
    },
    {
      enabled: !!id && !!episodeId,
      staleTime: 5 * (60 * 1000), 
      cacheTime: 7 * (60 * 1000),
    }
  );

  return {...query};
};
